import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import SpectrumV2Provider from '@react/react-spectrum/Provider';
import {
  Provider as SpectrumV3Provider,
  defaultTheme
} from '@adobe/react-spectrum';

import { ApolloProvider } from '@apollo/client';

import { PATHS } from '../config/constants';
import { routes as extensionRoutes } from '../config/extensions';

import A from '../services/analytics';
import apolloClient from 'services/apolloClient';

import { RootContextProvider } from './RootContext';
import { FeaturesContextProvider } from '../features/FeaturesContext';

import App from '../views/App';
import Home from '../views/Home';
import QuickSetup from 'views/QuickSetup';
import AEPDetails from '../views/details/AEPDetails';
import AdminRedirect from '../views/AdminRedirect';

import './Root.scss';

A.init();

export default function Root() {
  return (
    <ApolloProvider client={apolloClient}>
      <SpectrumV2Provider theme="light">
        <SpectrumV3Provider theme={defaultTheme} colorScheme="light">
          <BrowserRouter basename={PATHS.BASE}>
            <RootContextProvider>
              <FeaturesContextProvider>
                <App>
                  <Switch>
                    <Route
                      exact
                      path={PATHS.QUICK_SETUP}
                      component={QuickSetup}
                    />
                    <Route
                      exact
                      path={`${PATHS.AEP_DETAILS}/:id`}
                      component={AEPDetails}
                    />
                    {extensionRoutes.map(({ path, component }) => (
                      <Route
                        key={path}
                        exact
                        path={path}
                        component={component}
                      />
                    ))}
                    <Route
                      path={'/environments/admin'}
                      component={AdminRedirect}
                    />
                    <Route path={PATHS.HOME} component={Home} />
                  </Switch>
                </App>
              </FeaturesContextProvider>
            </RootContextProvider>
          </BrowserRouter>
        </SpectrumV3Provider>
      </SpectrumV2Provider>
    </ApolloProvider>
  );
}
